import React, { FunctionComponent } from 'react';
import Popover from '@material-ui/core/Popover';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { PopoverComponentProps } from './PopoverComponent.types';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      padding: theme.spacing(1),
    },
  })
);

export const PopoverComponent: FunctionComponent<
  PopoverComponentProps
> = props => {
  const {
    anchorEl,
    anchorOrigin = {
      horizontal: 'center',
      vertical: 'bottom',
    },
    transformOrigin = {
      horizontal: 'center',
      vertical: 'top',
    },
    children,
    className,
    id,
    wrapWithTypography = true,
    onClose,
    open,
  } = props;
  const classes = useStyles();

  return (
    <Popover
      id={id}
      className={className}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
    >
      {wrapWithTypography ? (
        <Typography className={classes.typography}>{children}</Typography>
      ) : (
        <div>{children}</div>
      )}
    </Popover>
  );
};
